import { unit } from 'mathjs';

import { UnitSystem } from '../enums';

export const formatWeightInStandard = (weight: number, userStandard: UnitSystem) => {
  if (userStandard === UnitSystem.EU) {
    return `${Math.floor(weight)}kg`;
  }

  if (userStandard === UnitSystem.US) {
    const values = unit(weight, 'kg').splitUnit(['lbs', 'ounce']);
    return `${Math.floor(values[0].toNumber())}lbs ${Math.floor(values[1].toNumber())}`;
  }

  const values = unit(weight, 'kg').splitUnit(['stone', 'ounce']);
  return `${Math.floor(values[0].toNumber())}st ${Math.floor(values[1].toNumber())}`;
};

export const formatHeightInStandard = (height: number, userStandard: UnitSystem) => {
  if (userStandard === UnitSystem.EU) {
    return `${Math.floor(height)}cm`;
  }

  const values = unit(height, 'cm').splitUnit(['ft', 'in']);
  return `${Math.floor(values[0].toNumber())}ft ${Math.floor(values[1].toNumber())}`;
};
